export function preventDefault(e: { preventDefault(): void}) {
  e.preventDefault();
}


export function stopPropagation(e: { stopPropagation(): void; }) {
  e.stopPropagation();
}
